const initStream = (url, option) => {

	var madeIframe = 0;

	if (window.addEventListener) {
		window.addEventListener("message", setSessionCookie, false);
	}

	function setSessionCookie(msg) {
		if (msg && msg.data && typeof msg.data === 'string') {
			setCookie(msg.data);
		} else {
			setCookie();
		}
	}

	function getCookie(name) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) return parts.pop().split(';').shift();
	}

	function makeIframe(withSid) {
		var getChatEl = document.getElementById('vshChatID');

		var height

		if(option.modus == "chat"){
			height = "600px"
		}else if(option.modus == "feedback"){
			height = "250px"
		}else{
			height = "600px"
		}
		
		if (withSid) {
			getChatEl.innerHTML = `<iframe src="${url}&sid=${withSid}" width="100%" height="${height}" frameborder="no" scrolling="no"></iframe>`;
		} else {
			getChatEl.innerHTML = `<iframe src="${url}" width="100%" height="${height}" frameborder="no" scrolling="no"></iframe>`;
		}

		madeIframe = 1;
	}


	function setCookie(sessId) {
		if (sessId) {
			var utcExpireDate = new Date(86400000 + Date.now()).toUTCString(); // 24 h
			document.cookie = `sid=${sessId};path=/;expires=${utcExpireDate};SameSite=None;Secure`;
		}

		if (madeIframe === 0) {
			if (sessId) {
				makeIframe(sessId);
			} else {
				makeIframe();
			}
		}
	}

	// document.addEventListener('DOMContentLoaded', function () {
	// 	if (getCookie('sid')) {
	// 		makeIframe(getCookie('sid'));
	// 	} else {
	// 		setSessionCookie();
	// 	}
	// });

}

// document.addEventListener('DOMContentLoaded', function () { 
// 	if (document.getElementById('vshChatID')) {
// 		var vshurl = 'https://05.chatmodul.de/?name=e23bb9bf219f08a790e737cd467bf0b0'
// 		initStream(vshurl,{modus: "chat"});
// 	}
// })
